import { storeToRefs } from 'pinia'
import { useArticleStore } from '@/stores/article'
import type { GetArticlesParams } from '@/domain/repositories/article.repository'

export function useArticle() {
  const articleStore = useArticleStore()
  const { articles, loading, error, currentLimit, hasArticles, hasError, hasMore } =
    storeToRefs(articleStore)

  return {
    articles,
    loading,
    error,
    currentLimit,
    hasArticles,
    hasError,
    hasMore,
    fetchArticles: (params?: GetArticlesParams, append?: boolean) =>
      articleStore.fetchArticles(params, append),
    loadMore: articleStore.loadMore,
    reset: articleStore.reset,
    clearError: articleStore.clearError,
  }
}
